module.exports = __webpack_public_path__ + "img/02-10.cf92266f.png";